import { useQuery } from "@tanstack/react-query";
import { useAppService } from "../../use-app-service";
import { productKeys } from "../query-keys";

interface GetProductsQueryParams {
  nominatedPurchaserId: string;
  enabled?: boolean;
}

export const useGetProductSalePricesQuery = (
  params: GetProductsQueryParams,
) => {
  const { nominatedPurchaserId, enabled } = params;
  const service = useAppService();

  const req = {
    nominatedPurchaserId,
  };

  return useQuery({
    queryKey: productKeys.getProductSalePrices(nominatedPurchaserId),
    queryFn: () => service.getProductSalePrices(req),
    enabled,
  });
};
